var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepartmentActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 9.625H15.575C16.5551 9.625 17.0451 9.625 17.4195 9.81574C17.7488 9.98352 18.0165 10.2512 18.1843 10.5805C18.375 10.9549 18.375 11.4449 18.375 12.425V18.375M11.375 18.375V5.425C11.375 4.44491 11.375 3.95486 11.1843 3.58052C11.0165 3.25123 10.7488 2.98352 10.4195 2.81574C10.0451 2.625 9.55509 2.625 8.575 2.625H5.425C4.44491 2.625 3.95486 2.625 3.58052 2.81574C3.25123 2.98352 2.98352 3.25123 2.81574 3.58052C2.625 3.95486 2.625 4.44491 2.625 5.425V18.375M19.25 18.375H1.75M5.6875 6.125H8.3125M5.6875 9.625H8.3125M5.6875 13.125H8.3125",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentActive);
export default __webpack_public_path__ + "static/media/department-active.cf069b9369939eab80070fd3ceac586a.svg";
export { ForwardRef as ReactComponent };